/** Shared enterprise shell tokens for all dashboards. */

export const DASH = {
  bg: "#f3f4f8",
  surface: "#ffffff",
  surface2: "#f7f8fb",
  border: "#e3e5ee",
  text: "#161a3a",
  muted: "#646a8a",
  faint: "#9aa0bb",
  navy: "#1b1f4b",
  accent: "#2f5bea",
  font: '"Open Sans", "Roboto", Helvetica, Arial, sans-serif',
  radius: "10px",
  gap: 12,
  shadow: "none",
  scrollThumb: "#9aa8d6",
  scrollThumbHover: "#2f5bea",
  scrollTrack: "#eef1f8",
};

/** Full-bleed page shell — cancels Layout `.has-padding` (20px). */
export const dashPageSx = {
  bgcolor: DASH.bg,
  boxSizing: "border-box",
  color: DASH.text,
  display: "flex",
  flexDirection: "column",
  fontFamily: DASH.font,
  fontSize: 13.5,
  gap: 1.5,
  lineHeight: 1.4,
  m: "-20px",
  minHeight: "calc(100vh - 64px)",
  overflow: "visible",
  pb: 3,
  pt: 1.5,
  px: 1.5,
  width: "auto",
};

export const dashCardSx = {
  bgcolor: DASH.surface,
  border: `1px solid ${DASH.border}`,
  borderRadius: DASH.radius,
  boxShadow: DASH.shadow,
};

/** Thin themed scrollbar for MUI `sx` on overflow containers */
export const dashScrollbarSx = {
  scrollbarWidth: "thin",
  scrollbarColor: `${DASH.scrollThumb} ${DASH.scrollTrack}`,
  "&::-webkit-scrollbar": {
    height: 6,
    width: 6,
  },
  "&::-webkit-scrollbar-track": {
    background: DASH.scrollTrack,
    borderRadius: 99,
  },
  "&::-webkit-scrollbar-thumb": {
    background: DASH.scrollThumb,
    borderRadius: 99,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: DASH.scrollThumbHover,
  },
  "&::-webkit-scrollbar-corner": {
    background: "transparent",
  },
};

/** GlobalStyles fragment for Layout `.main-view` page scroll */
export const dashMainViewScrollbarStyles = {
  ".main-view": {
    scrollbarWidth: "thin",
    scrollbarColor: `${DASH.scrollThumb} ${DASH.scrollTrack}`,
  },
  ".main-view::-webkit-scrollbar": {
    width: 8,
    height: 8,
  },
  ".main-view::-webkit-scrollbar-track": {
    background: DASH.scrollTrack,
  },
  ".main-view::-webkit-scrollbar-thumb": {
    background: DASH.scrollThumb,
    borderRadius: 99,
  },
  ".main-view::-webkit-scrollbar-thumb:hover": {
    background: DASH.scrollThumbHover,
  },
};
